$("a.video").each(function () {
    const video = $(this);
    const thisInner = video.html();

    // Set attributes
    const className = video.attr('class');
    const classAttributes = className ? `class="${className}"` : '';
    const bsToggle = video.attr('data-bs-toggle');
    const dataAttributesBsToggle = bsToggle ? `data-bs-toggle="${bsToggle}"` : '';
    const bsTarget = video.attr('data-bs-target');
    const dataAttributesBsTarget = bsTarget ? `data-bs-target="${bsTarget}"` : '';
    const mfpSrc = video.data('mfp-src');
    const dataAttributes = mfpSrc ? `data-mfp-src="${mfpSrc}"` : '';
    const href = video.attr('href');
    const hrefAttribute = href ? `data-href="${href}"` : '';
    // Apply attributes
    const buttonAttributes = `${classAttributes} ${dataAttributesBsToggle} ${dataAttributesBsTarget} ${dataAttributes} ${hrefAttribute}`.trim();

    // Construct and replace with button
    video.replaceWith('<button type="button" '+buttonAttributes+'>'+thisInner+'</button>');
});

$("a.video-mp4").each(function () {
    const video = $(this);
    const thisInner = video.html();

    // Set attributes
    const className = video.attr('class');
    const classAttributes = className ? `class="${className}"` : '';
    const vttSrc = video.data('vtt-src');
    const dataAttributesVTTSrc = vttSrc ? `data-vtt-src="${vttSrc}"` : '';
    const vttLabel = video.data('vtt-label');
    const dataAttributesVTTLabel = vttLabel ? `data-vtt-label="${vttLabel}"` : '';
    const vttSrcLang = video.data('vtt-srclang');
    const dataAttributesVTTSrcLang = vttSrcLang ? `data-vtt-srclang="${vttSrcLang}"` : '';
    const ariaLabel = video.attr('aria-label');
    const ariaLabelAttribute = ariaLabel ? `aria-label="${ariaLabel}"` : '';
    // Apply attributes
    const buttonAttributes = `${classAttributes} ${dataAttributesSrc} ${dataAttributesVTTSrc} ${dataAttributesVTTLabel} ${dataAttributesVTTSrcLang} ${ariaLabelAttribute}`;

    // Construct and replace with button
    video.replaceWith('<button '+buttonAttributes+'>'+thisInner+'</button>');
});
